// Wortlaute der Erklärung „Projekte“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Register stehen so, wie das Projekt sie zeigt (../project.js).
export default {
  title: "Projekte",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    ProjectOverview: "Projektliste",
    ProjectDetail: "Projekt",
    CustomerDetail: "Kunde",
    UserPositionOverview: "Personalrollen",
    CategoryOverview: "Kategorien",
    MaterialOverview: "Pakete",
    ProjectCostsForOne: "Projektkosten",
  },
  // Die Seiten außerhalb der Projekte, aus denen ein Projekt seine Inhalte bezieht und auf denen
  // seine eigenen Inhalte wieder auftauchen.
  related: "Zusammenhänge",
  step: {
    table: {
      text: "Hier stehen alle Projekte mit Kennung, Kunde und Ort, der Bauzeit mit einem Balken, wie weit sie fortgeschritten ist, der Bauleitung und, mit Kostenrecht, dem Budget. Ein Klick auf die Zeile öffnet das Projekt.",
    },
    row: {
      text: "Der Pfeil am Ende der Zeile oder ein Rechtsklick auf die Zeile klappt das Projekt auf, ohne es zu öffnen: seine Phasen, die Baustelle, die Bauleitung und wie viele Berichte, Maschinen und Materialien es hat. Ein Klick auf eine Anzahl öffnet das Projekt im passenden Register.",
    },
    pin: {
      text: "Mit der Nadel heften Sie ein Projekt oben an die Liste an, über alle anderen. Das gilt nur für Sie: Die Listen Ihrer Kollegen bleiben, wie sie sind. Ein zweiter Klick löst es wieder.",
    },
    create: {
      text: "Über diese Schaltfläche legen Sie ein neues Projekt an.",
    },

    head: { text: "Oben steht, um welches Projekt es geht, dazu seine Kennung und wer es angelegt hat." },
    actions: {
      text: "In diesem Menü liegen die Aktionen für das ganze Projekt. Duplizieren legt eine Kopie samt Berichten und Dateien an, Löschen entfernt das Projekt.",
    },
    costs: {
      text: "Die Mitlaufende Nachkalkulation führt zu den Kosten dieses Projekts. Dort stehen auch Erlöse und die Abweichung vom Budget.",
    },
    "action-planning": {
      text: "Hier geht es in die Personalplanung. Steckt das Projekt schon in einem Kalender, öffnet sich dieser, sonst legen Sie einen neuen mit dem Projekt an.",
    },
    "action-invoice": {
      text: "[[hwi]] starten öffnet die Abrechnung mit diesem Projekt. Sie müssen es dort nicht erneut auswählen.",
    },
    "action-customer": {
      text: "Kunde öffnen springt zum Kunden des Projekts. Dort stehen seine Ansprechpartner und Preise.",
    },
    tabs: {
      text: "Diese Leiste führt durch alle Register des Projekts. Das geöffnete Register steht auch in der Adresse, ein Link zeigt also immer dieselbe Stelle.",
    },
    "general-base": {
      text: "Name und Kennung benennen das Projekt. Die Bauzeit begrenzt, wann Phasen und [[cr.pl]] liegen dürfen.",
    },
    "general-customer": {
      text: "Der Kunde ist nach dem Anlegen fest. Er bestimmt Währung, Ansprechpartner und die Preise, die dieses Projekt übernimmt.",
    },
    "general-location": {
      text: "Die Adresssuche füllt Straße, Ort und Land auf einmal aus. Dabei setzt sie auch die Nadel auf der Karte.",
    },
    "general-address-manual": {
      text: "Über Adresse manuell bearbeiten ändern Sie die Felder von Hand. Die Nadel auf der Karte wandert dabei nicht mit.",
    },
    "general-map-pin": {
      text: "Ein Klick in die Karte setzt die Nadel an diese Stelle. Das geht, solange die Adressfelder offen sind.",
    },
    phases: {
      text: "Phasen teilen die Bauzeit in Abschnitte. Die Einsatzplanung plant Personal auf diese Abschnitte.",
    },
    "construction-reports": {
      text: "[[cr.pl]] halten fest, was an einem Tag auf der Baustelle geschah. Ein Tag im Kalender zeigt nur die Berichte dieses Tages.",
    },
    "hourly-wage-reports": {
      text: "[[hwr.pl]] erfassen Leistungen, die nach Aufwand abgerechnet werden. Aus ihnen entsteht später [[hwi:der/die/das]] [[hwi]]. Der Kalender zeigt, an welchen Tagen es Berichte gibt und ob sie gedruckt sind, und filtert die Liste nach Ausführungsdatum.",
    },
    times: {
      text: "Hier stehen die Zeiten, die Ihre Leute auf dieses Projekt erfasst haben. Das Register gehört zur Zeiterfassung.",
    },
    contacts: {
      text: "Aus den Ansprechpartnern des Kunden wählen Sie hier die für diese Baustelle aus. Neue Personen legen Sie gleich hier an.",
    },
    users: {
      text: "Hier steht, wer auf dem Projekt arbeitet. Leitendes Personal trägt ein farbiges Helm-Symbol und steht auch in der Projektliste. Bei allen anderen erscheint der Helm erst, wenn Sie über die Zeile fahren; ein Klick darauf macht die Person leitend. Neu hinzugefügtes Personal bringt seine Personalrolle mit; fehlt sie dem Projekt noch, wird sie unter Personalrollen ergänzt.",
    },
    "user-positions": {
      text: "Der Stundensatz einer Personalrolle am Projekt ist der Verkaufspreis für eine Stunde. Fehlt er, meldet der Reiter das mit einer Zahl. Eine entfernte Rolle verliert auch das Personal, das sie hat.",
    },
    machines: {
      text: "Maschinen für dieses Projekt, jede mit Einkaufspreis und Verkaufspreis je Stunde. Geräte-Nummern halten fest, welches Gerät gemeint ist.",
    },
    "machine-rentals": {
      text: "Ein gemietetes Gerät kostet vom Mietbeginn bis zum Mietende, nicht nach seinen Berichten. Woche und Monat zählen jede angefangene Einheit, Zubehör und Transporte kommen dazu. Tage ohne Einsatz kosten, was der Lieferant dafür ansetzt, etwa 10 % am Sonntag.",
    },
    "machine-rental-accessories": {
      text: "Zubehör wie der Tieflöffel fährt mit der Miete mit, über dieselben Tage in seiner Einheit mal Menge. Gewählt wird es unter „Bearbeiten“ der Miete aus dem Zubehör der Lieferanten, das des Mietlieferanten steht oben.",
    },
    materials: {
      text: "Materialien für dieses Projekt. Der Verkaufspreis ist entweder ein fester Preis oder ein Aufschlag auf den Einkaufspreis.",
    },
    "material-prices": {
      text: "Der Einkaufspreis kommt vom Lieferanten, bei dem das Projekt kauft. Unter „Ändern“ stehen alle Lieferanten mit ihrem Preis, die Wahl wird mit dem Projekt gespeichert.",
    },
    "material-object-price": {
      text: "Ein Objektpreis ist der Sonderpreis eines Lieferanten für dieses Projekt. Jeder Bericht, der diesen Lieferanten bucht, rechnet mit ihm.",
    },
    "material-picker": {
      text: "Hier stehen die Materialien und Pakete des Betriebs, die dem Projekt noch fehlen. Ein Klick darauf fragt den Verkaufspreis ab.",
    },
    efforts: {
      text: "Zusatzleistungen sind Pauschalen und Zuschläge, zum Beispiel Anfahrt oder Nachtarbeit.",
    },
    serviceCatalog: {
      text: "Das Leistungsverzeichnis aus dem Angebot mit Titeln und Positionen. Gebucht wird [[cr:im/in der/im]] [[cr]], hier sehen Sie den Leistungsstand und den Fortschritt jeder Position.",
    },
    "service-catalog-row": {
      text: "Mit dem Stift am Zeilenende bearbeiten Sie eine Position oder einen Titel direkt in der Tabelle. Neue Zeilen fügen Sie in der letzten Zeile der Tabelle hinzu, nach dem Speichern steht die nächste schon offen. Gespeichert wird mit ✓ oder Enter, und auch, sobald Sie woanders hinklicken.",
    },
    "service-catalog-fold": {
      text: "Ein Klick in die Spalte Pos-Nr. klappt auf und zu. Ein Titel zeigt so seine Positionen, eine Position ihren Langtext.",
    },
    "service-catalog-progress": {
      text: "Zum Stichtag, etwa für die Abschlagsrechnung, tragen Sie hier den Leistungsstand vieler Positionen untereinander ein. Ein Stand ist die Gesamtmenge bis zu diesem Tag, Buchungen bis dahin sind darin enthalten. Die Stände einer Position zeigt ihr Verlauf im Zeilenmenü.",
    },
    files: {
      text: "Pläne, Fotos und Schriftverkehr zum Projekt liegen hier. Dieselben Dateien finden Sie unter Dateien wieder.",
    },
    configuration: {
      text: "Die Einstellungen gelten für dieses Projekt, etwa Währung und Arbeitstage.",
    },
    activity: {
      text: "Das Protokoll zeigt jede Änderung am Projekt, an seinem Leistungskatalog und an seinen Berichten; mit dem Filter grenzen Sie es ein. Unter Verweise steht, welche Datensätze auf das Projekt verweisen.",
    },
    save: {
      text: "Speichern sichert alle Register auf einmal. Fehlt in einem Register etwas, springt die Leiste dorthin.",
    },

    "customer-contacts": {
      text: "Ansprechpartner gehören dem Kunden. Im Register Ansprechpartner des Projekts wählen Sie daraus die für diese Baustelle.",
    },
    "customer-rates": {
      text: "Hat der Kunde eigene Stundensätze, gelten sie als Vorschlag für die Personalrollen eines Projekts dieses Kunden.",
    },
    "customer-prices": {
      text: "Auch Preise für Material, Maschinen und Zusatzleistungen kann der Kunde eigene haben. Das Projekt übernimmt sie beim Hinzufügen.",
    },
    positions: {
      text: "Eine Personalrolle bringt ihren Stundensatz mit. Er ist der Vorschlag, wenn Sie die Rolle einem Projekt hinzufügen.",
    },
    "categories-list": {
      text: "Hier stehen alle Kategorien des Betriebs. Angelegt, umbenannt und gelöscht werden sie direkt im Kategorienfeld [[hwr:eines/einer/eines]] [[hwr.gen]].",
    },
    packets: {
      text: "Ein Paket bündelt Material, Maschinen oder Zusatzleistungen. Im Projekt steht es im Hinzufügen-Fenster und trägt alle Positionen auf einmal ein.",
    },
    "costs-services": {
      text: "Aus den gebuchten Mengen des Leistungskatalogs wird hier der Leistungswert. Lewara stellt ihn den bisherigen Kosten des Projekts gegenüber.",
    },
  },
}
